import * as React from 'react';
import { Input, Select } from 'antd';
import * as update from 'immutability-helper';
import StaticView from './StaticView';
const Option = Select.Option;
const InputGroup = Input.Group;
import { get } from 'pc-sales/utils/http';
import statics from 'common/statics';

interface PhoneState {
    codes: Array<{
        key: string;
        name: string;
        phone_code: string;
        countryKey: string;
    }>;
    phoneCode: string;
}
const keyMap = {
    '1': 'CHN',
    '71': 'TWN',
    '81': 'HKG',
    '82': 'MAC'
};
export default class PhoneTemp extends React.Component<any, PhoneState> {
    static fieldName = 'phone';
    static defaultProps = {
        lang: 'zh-CN',
        ipConfig: '/v2/control/location/show',
        preventIpConfig: false
    };
    mounted: boolean = null;

    // 值变化
    changeHandler = (index: 0 | 1) => (data: string) => {
        const { value, onChange } = this.props;
        onChange && onChange(update((value || [this.state.phoneCode]), {
            [index]: { $set: index === 0 ? data.match(/\+\d+/)[0] : data },
            ...(index === 0 ? { 2: { $set: data.match(/\s(\S*)/)[1] } } : {})
        }));
    };

    // 失焦
    blurHandler = () => {
        const { value, onBlur } = this.props;
        onBlur && onBlur(value);
    };

    constructor(props: any) {
        super(props);
        this.state = {
            codes: null,
            phoneCode: null
        };
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    async componentDidMount() {
        this.mounted = true;
        let { ipConfig, initialValue, preventIpConfig, extension, countryList: codes } = this.props;
        if (!codes) {
            const [phoneCodes] = await statics.index('phoneCodes');
            codes = phoneCodes;
        }
        extension && extension(codes);
        let phoneCode = codes[0].phone_code;
        // 是否启用ip识别
        if (!!ipConfig && !preventIpConfig) {
            if (initialValue && initialValue[0]) {
                phoneCode = initialValue[0];
            } else {
                const ipPhoncode = window.localStorage.getItem('ipPhoncode');
                if (!ipPhoncode) {
                    const location = await get(ipConfig).catch(); // 地区信息
                    const phone: any = codes.find((val: any) => val.key === (location.value || '1')); // 区号信息
                    phoneCode = phone && phone.value || codes[0].phone_code;
                    this.props.onChange([phoneCode]);
                } else {
                    this.props.onChange([ipPhoncode]);
                }
            }
        }
        this.mounted && this.setState({ codes, phoneCode });
    }

    getKey = (codes: any) => {
        const { phone_country } = this.props;
        if (phone_country) {
            let res = codes && codes.filter((item: any) => item.key === phone_country);
            let key = res && res.length ? res[0].key : '';
            return this.formatKey(key);
        }
        return '';
    }

    // 调整显示中国大陆/中国台湾/中国香港/中国澳门的key值
    formatKey = (originKey: string) => {
        if (originKey && originKey in keyMap) {
            return keyMap[originKey];
        }
        return originKey;
    }

    render() {
        const { placeholder, initialValue, disabled, staticView, value, showDecrypt, decryptConfig, countryList, phone_country, contentType } = this.props;
        let { codes, phoneCode } = this.state;
        if (countryList) codes = countryList;
        const code = (value && value[0]) || phoneCode || window.localStorage.getItem('ipPhoncode');
        const phoneCountryKey = this.getKey(codes);
        let res = codes && codes.filter((item: any) => item.phone_code === code);
        let key = res && res.length ? (contentType === 'clue' ? res[0].countryKey : res[0].key) : '';
        const countryKey = (value && value[2] && this.formatKey(value[2])) || this.formatKey(phone_country) || this.formatKey(key);
        return (
            (staticView && disabled)
                ? <StaticView
                    display={initialValue}
                    showDecrypt={showDecrypt}
                    decryptConfig={decryptConfig}
                    adaptFn={(val: any) => val && val[1] && `(${val[0]} ${phoneCountryKey}) ${val[1]}`}
                    phoneCountryKey={phoneCountryKey}
                />
                : <InputGroup
                    compact
                    style={{ height: 32, display: "flex" }}
                    className={(staticView && disabled) ? 'Form-static-view' : ''}>
                    <Select
                        placeholder={placeholder[0]}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{ width: 'auto' }}
                        onChange={this.changeHandler(0)}
                        style={{ minWidth: 100}}
                        value={`(${code}) ${countryKey}`}
                        filterOption={(inputValue: any, option: any) => {
                            if (option) {
                                const text = option.props.children;
                                const result = text.indexOf(inputValue) > -1;
                                return result ? true : false;
                            } else {
                                return false;
                            }
                        }}
                        optionLabelProp='label'
                        disabled={disabled}
                        showSearch
                    >
                        {codes && codes.map(({ key, name, phone_code, countryKey: cKey }) =>
                            <Option
                                key={`(${phone_code}) ${key}`}
                                label={contentType === 'clue' ? `(${phone_code}) ${cKey}` : `(${phone_code}) ${name}`}
                                value={`(${phone_code}) ${contentType === 'clue' ? cKey : key}`}
                            >
                                {`(${phone_code}) ${name}`}
                            </Option>)}
                    </Select>
                    <Input
                        placeholder={placeholder[1]}
                        defaultValue={(initialValue && initialValue[1]) || ''}
                        value={(value && value[1]) || ''}
                        onChange={(e: any) => this.changeHandler(1)(e.target.value)} onBlur={this.blurHandler}
                        style={{ flex: "1" }} disabled={disabled}
                    />
                </InputGroup>
        );
    }
}
